"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WageType = void 0;
var WageType;
(function (WageType) {
    WageType["W2"] = "W2";
    WageType["CONTRACTOR"] = "CONTRACTOR";
})(WageType || (exports.WageType = WageType = {}));
